'use strict';
var trainsMapTpl = require('../views/map.html');

module.exports = /*@ngInject*/ function trainsMap() {
    return {
        restrict: 'E',
        template: trainsMapTpl,
        controller: 'MapMonitoringViewController',
        controllerAs: 'vm',
        scope: {},
        bindings: {
            trains: '<',
            projectId: '<',
            zoom: '<',
            investigateTrain: '&'
        },
        bindToController: true // because the scope is isolated
    };

}
